import { FlyerType } from '@/config/constants';

export type FlyerPage = {
  imageUrl: string;
  userText: string;
  pageNumber: number;
};

type Branding = {
  logoAlt: string;
  logoLinkUrl: string;
  logoUrl: string;
};

export type School = {
  schoolId: string;
  name: string;
  branding: Branding;
};

export type FlyerThumbnail = {
  flyerId: number;
  title: string;
  frontImageUrl: string;
};

export type Org = {
  orgId: string;
  name: string;
  description: string;
  disclaimer: string;
  schoolApproved: boolean;
  links: {
    call: string;
    website: string;
    email: string;
  };
};

export type FlyerLinks = {
  androidAppUrl?: string;
  callNowUrl?: string;
  contactEmailUrl?: string;
  donateNowUrl?: string;
  iosAppUrl?: string;
  learnMoreUrl?: string;
  signUpNowUrl?: string;
  RSVPUrl?: string;
  registerPUrl?: string;
  orderUrl?: string;
  meetingUrl?: string;
  subscribeUrl?: string;
  surveyUrl?: string;
  downloadUrl?: string;
};

export type FlyerTypeItem = {
  id: string;
  name: string;
  icon: string;
  type: FlyerType;
  description: string;
};

export type FlyerCategory = {
  id: string;
  title: string;
  icon: string;
};

export type FlyerTypes = Array<FlyerTypeItem>;

export type FlyerCategories = Array<FlyerCategory>;

export enum FlyerStatus {
  active = 'active',
  expired = 'expired',
  removed = 'removed',
  pending = 'pending',
}

export type SavedSearch = {
  search: string;
  totalFlyers: number;
  totalNewFlyers: number;
};
